import { FETCH_SUGGESTIONS, FETCH_SEARCH } from './constants'

const initialState = {
  isFetching: false,
  isSearching: false,
  suggestions: [],
  results: [],
  total: 0
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SUGGESTIONS.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case FETCH_SUGGESTIONS.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        suggestions: action.results
      }
    }
    case FETCH_SEARCH.REQUEST: {
      return {
        ...state,
        isSearching: true
      }
    }
    case FETCH_SEARCH.SUCCESS: {
      return {
        ...state,
        isSearching: false,
        results: action.results,
        total: action.total
      }
    }
    default: {
      return state
    }
  }
}
